import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=cf6297e2&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cf6297e2')) {
      api.createRecord('cf6297e2', component.options)
    } else {
      api.reload('cf6297e2', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=cf6297e2&", function () {
      api.rerender('cf6297e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2z8z8a6v8x0MO/JS/comp/ImgFallback.vue"
export default component.exports